export const url = {
  funcList: '/auth/brand/inciFounction',
  funcTradeList: '/auth/public/tradeFunctions',
  ecoStatusesList: '/auth/public/ecoStatuses',
  segmentList: '/auth/public/segment_list',
  delivery: '/app/trade/tradeFormDelivery',
  // inci
  INCIlist: '/auth/trade/inci/findList',
  INCIDetail: '/auth/trade/inci/detail',
  INCIAppAnalysis: '/auth/trade/inci/detail/INCIAppAnalysis',
  INCItop10: '/auth/trade/inci/detail/top10ProductContainInci',
  INCIMoreFormulation: '/auth/trade/inci/detail/getCombineRelativeFormulation',
  INCIMoreINCI: '/auth/trade/inci/detail/getCombineRelativeIngredient',
  group: '/auth/brand/selectGroup',
  brand: '/auth/brand/groupAndBrand',
  // tradeName
  tradeList: '/auth/trade/web/findList',
  tradeDetail: '/auth/trade/findWebDetail',
  relatedFormulation: '/IngredientDetails',
  // download
  download: '/auth/public/download_file',
  getGoodsSubCategory: '/auth/public/get_goodsSubCategory',
  getReleaseCountry: '/auth/releaseCountry/list',
  getRelatedFormulation: '/auth/trade/inci/relatedFormulation'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/ingredientSelection.js